<template>
    <div class="status">
        <p class="title">{{ title }}</p>

        <div class="checkbox alt js-badge"
             v-if="badgeDiscount"
        >
            <label>
                <input type="checkbox"
                       name="badges[]"
                       :value="badgeDiscount.id"
                       @change="handleChange"
                >
                <span class="check">
                    <img src="/img/icons/check-white.svg" v-svg-inline>
                </span>
                <span class="label">
                    {{ badgeDiscount.name }}
                </span>
            </label>
        </div>

<!--        <div class="checkbox alt js-badge"-->
<!--             v-if="badgeOutOfStock"-->
<!--        >-->
<!--            <label>-->
<!--                <input type="checkbox"-->
<!--                       name="badges[]"-->
<!--                       :value="badgeOutOfStock.id"-->
<!--                       @change="$emit('on-badge-changed')"-->
<!--                >-->
<!--                <span class="check">-->
<!--                    <img src="/img/icons/check-white.svg" v-svg-inline>-->
<!--                </span>-->
<!--                <span class="label">-->
<!--                    {{ badgeOutOfStock.name }}-->
<!--                </span>-->
<!--            </label>-->
<!--        </div>-->

        <div class="checkbox alt js-badge"
             v-for="(badge, key) in items"
             :key="key"
        >
            <label>
                <input type="checkbox"
                       name="badges[]"
                       :value="badge.id"
                       @change="handleChange"
                >
                <span class="check">
                    <img src="/img/icons/check-white.svg" v-svg-inline>
                </span>
                <span class="label">
                    {{ badge.name }}
                </span>
            </label>
        </div>

        <div class="checkbox alt js-badge"
             v-if="badgeWolt"
        >
            <label>
                <input type="checkbox"
                       name="badges[]"
                       :value="badgeWolt.id"
                       @change="handleChange"
                >
                <span class="check">
                    <img src="/img/icons/check-white.svg" v-svg-inline>
                </span>
                <span class="label">
                    {{ badgeWolt.name }}
                </span>
            </label>
        </div>
    </div>
</template>

<script>
import { onMounted, inject } from 'vue'
import { setCheckbox } from '../../functions/helpers'

export default {

    emits: ['on-badge-changed'],

    props: [
        'items',
        'title'
    ],

    setup(props, { emit }) {

        const emitter   = inject('emitter')
        const constants = inject('constants')
        const badgeDiscount = JSON.parse(constants.badgeDiscount)
        const badgeWolt = JSON.parse(constants.badgeWolt)
        const badgeOutOfStock = JSON.parse(constants.badgeOutOfStock)

        onMounted( () => {
            emitter.on('set-values-from-parameters', ( {badges} ) => {
                if ( badges && badges.length > 0  )
                    setCheckbox('.js-badge input', badges.split(','))
            })
        })

        function handleChange() {
            if ( constants.clientWidth > 991 ) emit('on-badge-changed')
        }

        return {
            badgeDiscount,
            badgeWolt,
            badgeOutOfStock,
            handleChange
        }
    }
}
</script>
